import React from 'react';
import {
  addressUI,
  arrayBuilderItemFirstPageTitleUI,
  textUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import { providerFacilityItemSchema } from '../../../schema';

const { providerFacilityName, providerFacilityAddress } =
  providerFacilityItemSchema.properties;

export const ProviderDetailsDescription = (
  <p>
    Tell us where a private (non-VA), Vet Center, or Community Care healthcare
    provider treated you for your condition. We’ll use the information you enter
    to locate your records. You can add more providers later.
  </p>
);

const addressUiSchema = addressUI({
  omit: ['isMilitary', 'street3'],
  labels: {
    street: 'Street address (20 characters maximum)',
    street2: 'Street address (20 characters maximum)',
  },
});

export default {
  uiSchema: {
    ...arrayBuilderItemFirstPageTitleUI({
      title: 'Details about other healthcare providers',
      nounSingular: 'provider',
      lowerCase: false,
      description: ProviderDetailsDescription,
    }),
    providerFacilityName: textUI({
      title: 'Name of private provider or hospital',
      errorMessages: {
        required: 'Enter the name of the provider or hospital',
      },
    }),
    providerFacilityAddress: {
      ...addressUiSchema,
      // addressPattern.jsx's `replaceSchema` hardcodes the city title to
      // "City", ignoring `addressUI`'s `labels.city` option. A static
      // `ui:title` here still wins, since FieldTemplate reads
      // `uiSchema['ui:title']` before falling back to the widget's label.
      city: {
        ...addressUiSchema.city,
        'ui:title': 'City (30 characters maximum)',
      },
    },
  },
  schema: {
    type: 'object',
    required: ['providerFacilityName', 'providerFacilityAddress'],
    properties: {
      providerFacilityName,
      providerFacilityAddress,
    },
  },
};
